module.exports = __webpack_public_path__ + "static/media/confirm-password-selected.76bfa7ee.svg";